import React from 'react';

export const ErrorContext = React.createContext(null);

export const ErrorProvider = ErrorContext.Provider;

export default ErrorContext;
